import React from "react";
import Helmet from "react-helmet";
import { Card, CardBody, Col, Container, Label, Row } from "reactstrap";
// images
import lock from "../../../assets/images/lock.svg";
import logo from "../../../assets/images/logo_new.svg";

//i18n
import { useTranslation } from "react-i18next";

import CustomButton from "../../../components/customButton/customButton";
import HookForm from "../../../components/hookForm/hookForm";
import TextField from "../../../components/textField/textField";

const SetPasswordComponent = (props) => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  const {
    resetForm,
    t_show2,
    t_show,
    multiErrorFields,
    showconfirm,
    show,
    onFormSubmit,
    busy,
  } = props;

  return (
    <React.Fragment>
      <Helmet>
        <title>Reset Password | RizzTix </title>
      </Helmet>
      <div className="authPages resetPasswordPage">
        <Container>
          <Row className="justify-content-center">
            <div className="logoDiv">
              <img src={logo} alt="logo" />
            </div>
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden forgotStyle">
                <div className="bg-primary topContainRow">
                  <Col className="col-7">
                    <h5 className="text-primary">{t("SET_PASSWORD")}</h5>
                    <p className="text-primary small mb-0 pe-2">
                      {t("SET_PASSWORD_INVITE_EXPLANATION")}
                    </p>
                  </Col>
                  <Col className="col-5 d-flex justify-content-end">
                    <img src={lock} alt="" className="img-fluid" />
                  </Col>
                </div>
                <CardBody className="Card_Body">
                  <div className="p-2">
                    <HookForm
                      defaultForm={{}}
                      // init={(from) => setResetForm(resetform)}
                      onSubmit={(e) => onFormSubmit(e)}
                    >
                      {(formMethod) => {
                        return (
                          <div
                            className={
                              formMethod?.formState.errors ? "invalid" : ""
                            }
                          >
                            <div className="mb-4">
                              <div className="d-flex">
                                <Label>{t("NEW_PASSWORD")}</Label>
                                <Label className="requiredStyle">*</Label>
                              </div>
                              <div className="input-group auth-pass-inputgroup">
                                <TextField
                                  formMethod={formMethod}
                                  rules={resetForm.newpassword.validate}
                                  multiErrorFields={multiErrorFields}
                                  errors={formMethod?.formState.errors}
                                  name={resetForm.newpassword.name}
                                  iconError={formMethod?.formState.errors}
                                  type={!show ? "text" : "password"}
                                  placeholder={t("Enter new password")}
                                  iconRightShow={true}
                                  onChange={(value) => {
                                    formMethod?.watch("password") &&
                                      formMethod.trigger("password");
                                  }}
                                  defaultValue=""
                                />
                                <button
                                  tabindex="-1"
                                  onClick={t_show}
                                  className="btn btn-light "
                                  type="button"
                                  id="password-addon"
                                >
                                  <i
                                    className={
                                      !show
                                        ? "mdi mdi-eye-outline"
                                        : "mdi mdi-eye-off-outline"
                                    }
                                  ></i>{" "}
                                </button>
                              </div>
                            </div>
                            <div className="mb-4">
                              <div className="d-flex">
                                <Label>{t("CONFIRM_PASSWORD")}</Label>
                                <Label className="requiredStyle">*</Label>
                              </div>
                              <div className="input-group auth-pass-inputgroup">
                                <TextField
                                  formMethod={formMethod}
                                  rules={{
                                    required: {
                                      value: true,
                                      message: t(
                                        "PLEASE_ENTER_CONFIRM_PASSWORD"
                                      ),
                                    },
                                    validate: {
                                      matchPassword: (value) =>
                                        (value &&
                                          value ===
                                            formMethod?.watch("newpassword")) ||
                                        t("BOTH_PASSWORD_MUST_BE_MATCH"),
                                    },
                                  }}
                                  name={resetForm.password.name}
                                  errors={formMethod?.formState.errors}
                                  type={!showconfirm ? "text" : "password"}
                                  placeholder={t("Confirm password")}
                                  onChange={(e) => {
                                    formMethod?.watch("newpassword") &&
                                      formMethod.trigger("newpassword");
                                  }}
                                />
                                <button
                                  tabindex="-1"
                                  onClick={t_show2}
                                  className="btn btn-light "
                                  type="button"
                                  id="password-addon"
                                >
                                  <i
                                    className={
                                      !showconfirm
                                        ? "mdi mdi-eye-outline"
                                        : "mdi mdi-eye-off-outline"
                                    }
                                  ></i>{" "}
                                </button>
                              </div>
                            </div>
                            <div
                              className="d-grid"
                              style={{ marginBottom: 12 }}
                            >
                              <CustomButton
                                className="btn darkBtn btn-block"
                                type="submit"
                                title={t("SET_PASSWORD")}
                                disabled={!formMethod?.formState.isValid}
                                loading={busy}
                              />
                              {/* <CustomButton className='btn btn-primary btn-block mt-4 cancelBtnStyle' onClick={onClickCancel} type="button" title='Cancel' /> */}
                            </div>
                          </div>
                        );
                      }}
                    </HookForm>
                  </div>
                </CardBody>
              </Card>
              <div className="copyRightTextStyle text-center">
                <p>{`@${currentYear} ${t("COPYRIGHTS_BY_SIGN_IN")}`}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SetPasswordComponent;
